/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import * as R from 'ramda';
import React from 'react';

import BridgedIrame from './view.plugin.bridged.iframe';
import styles from './styles/index.styl';

const ViewPluginsManager = ({
  onLoadPlugin,
  onUnloadPlugin,
  plugins,
  selectedView
}) => {
  const iframeMapper = R.map(({ displayName, namespace, uuid }) => {
    const isSelected = selectedView === namespace;

    return (
      <BridgedIrame
        id={uuid}
        key={uuid}
        namespace={namespace}
        onLoadPlugin={onLoadPlugin}
        onUnloadPlugin={onUnloadPlugin}
        title={displayName}
        visible={isSelected}
      />
    );
  });

  return (
    <div className={styles.mainPanel} id="iframeArea">
      {plugins.length && iframeMapper(plugins)}
    </div>
  );
};

ViewPluginsManager.displayName = 'ViewPluginsManager';

export default ViewPluginsManager;
